import Link from '@mui/material/Link';
import { GridRenderCellParams } from '@mui/x-data-grid/models';
import React from 'react';
import { Link as LinkRouter } from 'react-router-dom';

interface Props {
	label: GridRenderCellParams;
	to: string;
}

export function LinkCell({ label, to }: Props) {
	return (
		<Link underline='hover' component={LinkRouter} to={to}>
			{label}
		</Link>
	);
}
